export default function ChevronRightIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="currentColor"
    >
      <path d="M13.9717 10C13.9717 10.2497 13.8701 10.4782 13.667 10.6855L8.7793 15.4653C8.69466 15.5457 8.60368 15.6071 8.50635 15.6494C8.40902 15.6875 8.30111 15.7065 8.18262 15.7065C8.02604 15.7065 7.88216 15.6685 7.75098 15.5923C7.61979 15.5161 7.51611 15.4146 7.43994 15.2876C7.36377 15.1564 7.32568 15.0125 7.32568 14.856C7.32568 14.619 7.41243 14.4116 7.58594 14.2339L12.2324 9.70801V10.2856L7.58594 5.77246C7.41243 5.59473 7.32568 5.38737 7.32568 5.15039C7.32568 4.99382 7.36377 4.85205 7.43994 4.7251C7.51611 4.59391 7.61979 4.49023 7.75098 4.41406C7.88216 4.33789 8.02604 4.2998 8.18262 4.2998C8.41536 4.2998 8.61214 4.38232 8.77295 4.54736L13.667 9.31445C13.7686 9.41602 13.8447 9.52393 13.8955 9.63818C13.9421 9.74821 13.9674 9.86882 13.9717 10Z" />
    </svg>
  );
}
